// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1LOO3","header":"PatientBlock_header__zM8GG","label":"PatientBlock_label__2-cVx","option":"PatientBlock_option__1YimM"};